/**
 * 현재 stage snapshot 의 전체 state JSON 을 그대로 덤프. 디버깅용.
 */

import type { StepwiseState } from './stages'

interface Props {
  snapshot?: StepwiseState
  html: string
  edited: boolean
}

export function StageDebugPanel({ snapshot, html, edited }: Props) {
  if (!snapshot) {
    return <div style={{ padding: 16, color: '#888' }}>아직 실행되지 않은 단계입니다.</div>
  }
  // html 은 별도 패널에서 보니 덤프에서는 길이만 표시.
  const { html: _snapshotHtml, ...rest } = snapshot
  const dump = {
    meta: {
      htmlLength: html.length,
      edited,
    },
    state: rest,
  }
  return (
    <pre
      style={{
        margin: 0,
        padding: 16,
        fontSize: 12,
        fontFamily: 'monospace',
        height: '100%',
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        background: '#0d0d0d',
        color: '#d4d4d4',
      }}
    >
      {JSON.stringify(dump, null, 2)}
    </pre>
  )
}
